<template>
    <el-col :xs="24" :md="12" :cols="12">
        <div id="colderecha">
            <template v-if="mode == 'agenda'">
                <h2>Agenda</h2>
                <div v-if="!loading" style="width: 100%;">
                    <div style="padding: 5px; display:flex; justify-content: space-between;">
                        <el-button type="warning" @click="$router.push('/dashboard')">Volver</el-button>
                        <el-button type="warning" @click="vaciarUser(); drawer = true"><font-awesome-icon
                                :icon="['fas', 'user-plus']" />
                            Añadir contacto</el-button>
                    </div>
                </div>
                <table style="width: 100%" v-loading="loading" class="display">
                    <thead>
                        <tr>
                            <th>Nombre</th>
                            <th>Cargo</th>
                            <th>Acciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="contacto in objetoCortado" :key="contacto.id">
                            <td>{{ contacto.name }}</td>
                            <td>{{ contacto.cargo }}</td>
                            <td><el-button @click="nuevoUsuario = contacto; drawer = true;" type="warning"><el-icon>
                                        <EditPen />
                                    </el-icon></el-button> <el-button @click="eliminar(contacto.id)"
                                    type="warning"><el-icon>
                                        <Delete />
                                    </el-icon></el-button></td>
                        </tr>
                    </tbody>
                </table>
                <el-pagination v-if="!loading" background class="mt-3" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" v-model:currentPage="paginaActual"
                    v-model:pageSize="objetosPorPagina" :page-sizes="[10, 20, 25, 50, 100, 150, 200]"
                    layout="prev, pager, next, jumper, sizes, total" :total="receptores.length">
                </el-pagination>
            </template>
            <el-drawer v-model="drawer" title="Agenda" direction="rtl">
                <div>
                    <b>Nombre</b>
                    <el-input style="margin-bottom: 20px;" v-model="nuevoUsuario.nombre" size="large"></el-input>
                    <b>Primer apellido</b>
                    <el-input style="margin-bottom: 20px;" v-model="nuevoUsuario.apellido1" size="large"></el-input>
                    <b>Segundo apellido</b>
                    <el-input style="margin-bottom: 20px;" v-model="nuevoUsuario.apellido2" size="large"></el-input>
                    <b>Email</b>
                    <el-input style="margin-bottom: 20px;" v-model="nuevoUsuario.email" size="large"></el-input>
                    <b>Número de móvil (con prefijo)</b>
                    <el-input style="margin-bottom: 20px;" v-model="nuevoUsuario.telefono" size="large"></el-input>
                    <b>Número de DNI/NIE/Otros (con letra)</b>
                    <el-input style="margin-bottom: 20px;" v-model="nuevoUsuario.dni" size="large"></el-input>
                    <b>Cargo</b>
                    <el-input style="margin-bottom: 20px;" v-model="nuevoUsuario.cargo" size="large"></el-input>
                    <el-switch style="--el-switch-on-color: #e6a23c; --el-switch-off-color: #ff4949"
                        v-model="validar" /> Usuario
                    nacional (con NIF/NIE y teléfono españoles)
                    <el-button @click="anadirExterno()" style="margin-top: 20px; width: 100%"
                        type="warning">Guardar</el-button>
                </div>
            </el-drawer>
        </div>
    </el-col>
</template>

<script>
import { ElNotification } from 'element-plus';
// import { curl } from '@/api.js';
import { mapMutations } from 'vuex'
import { mapState } from 'vuex'
export default {
    name: 'ListaAgenda',
    watch: {
    },
    data() {
        return {
            loading: false,
            router: this.$router,
            paginaActual: 1,
            objetosPorPagina: 50,
            filtros: {
                nombre: '',
                estado: '',
                fechaEnvio: '',
                destinatarios: ''
            },
            nuevoUsuario: {
                nombre: "",
                apellido1: "",
                apellido2: "",
                telefono: "+34",
                email: "",
                dni: "",
            },
            mode: 'agenda',
            validar: true,
            drawer: false,
        }
    },
    mounted() {

    },
    computed: {
        ...mapState([
            'datosemp', 'receptores', 'configEnvio', 'params'
        ]),
        objetoCortado() {
            let entries = this.receptores;
            // Aplicar slice para obtener una parte del objeto
            const start = (this.paginaActual - 1) * this.objetosPorPagina;
            const end = start + this.objetosPorPagina;
            let trozo = entries.slice(start, end);

            return trozo;
        }
    },
    methods: {
        ...mapMutations([
            'setDatosemp',
            'setReceptores',
            'setConfigEnvio',
            'setContent',
            'setPubTitulo'
        ]),
        vaciarUser() {
            this.nuevoUsuario = {
                nombre: "",
                apellido1: "",
                apellido2: "",
                telefono: "+34",
                email: "",
                dni: "",
            }
        },
        async eliminar(id) {
            this.loading = true;
            let resp = await fetch(process.env.VUE_APP_APIDOMAIN + 'firmas/eliminarContacto', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ token: this.datosemp.token, id })
            });
            if (resp.status == 200) {
                let respcontactos = await fetch(process.env.VUE_APP_APIDOMAIN + 'firmas/obtenerContactos', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ token: this.datosemp.token })
                });
                if (respcontactos.status == 200) {
                    this.setReceptores(await respcontactos.json());
                }
                ElNotification({
                    title: "Correcto",
                    message: "El contacto se ha eliminado correctamente",
                    type: "success",
                });
            } else {
                ElNotification({
                    title: "Error",
                    message: "No se ha podido eliminar el contacto",
                    type: "error",
                });
            }
            this.loading = false;
        },
        async anadirExterno() {
            this.loading = true;
            if (
                this.nuevoUsuario.nombre == "" ||
                this.nuevoUsuario.apellido1 == "" ||
                this.nuevoUsuario.apellido2 == "" ||
                this.nuevoUsuario.telefono == "" ||
                this.nuevoUsuario.email == "" ||
                this.nuevoUsuario.dni == "" ||
                this.nuevoUsuario.cargo == ""
            ) {
                ElNotification({
                    title: "Error",
                    message: "Por favor, rellena todos los datos",
                    type: "error",
                });
                return;
            } else {
                if (this.validar) {
                    let regex = /^(?:\+34)?[67][0-9]{8}$/;
                    if (!regex.test(this.nuevoUsuario.telefono)) {
                        ElNotification({
                            title: "Error",
                            message: "El formato del teléfono introducido no es correcto",
                            type: "error",
                        });
                        return;
                    } else {
                        this.nuevoUsuario.telefono = this.nuevoUsuario.telefono.startsWith('+34')
                            ? this.nuevoUsuario.telefono
                            : `+34${this.nuevoUsuario.telefono}`;
                    }
                }
                let regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
                if (!regex.test(this.nuevoUsuario.email)) {
                    ElNotification({
                        title: "Error",
                        message: "El email introducido no es correcto",
                        type: "error",
                    });
                    return;
                }
                if (this.validar) {
                    if (
                        !/^[0-9]{8}[TRWAGMYFPDXBNJZSQVHLCKE]$/i.test(this.nuevoUsuario.dni) &&
                        !/^[XYZ][0-9]{7}[TRWAGMYFPDXBNJZSQVHLCKE]$/i.test(
                            this.nuevoUsuario.dni
                        )
                    ) {
                        ElNotification({
                            title: "Error",
                            message: "El DNI/NIE introducido no es válido",
                            type: "error",
                        });
                        return;
                    }
                }
                this.nuevoUsuario.name = `${this.nuevoUsuario.nombre} ${this.nuevoUsuario.apellido1} ${this.nuevoUsuario.apellido2}`;
                this.nuevoUsuario.centro_id = 0;
                this.nuevoUsuario.disabled = false;
                this.nuevoUsuario.empresa = "FIRMANTE EXTERNO";
                this.nuevoUsuario.estado = null;
                this.nuevoUsuario.nombrecentro = "FIRMANTE EXTERNO";
                this.nuevoUsuario.selected = true;
                this.nuevoUsuario.tipo = "empleado";
                this.nuevoUsuario.externo = true;
                this.nuevoUsuario.user_mail = this.datosemp.mail;
                this.nuevoUsuario.token = this.datosemp.token;
                let resp = await fetch(process.env.VUE_APP_APIDOMAIN + 'firmas/crearContacto', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(this.nuevoUsuario)
                });
                if (resp.status == 200) {
                    let respcontactos = await fetch(process.env.VUE_APP_APIDOMAIN + 'firmas/obtenerContactos', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ token: this.datosemp.token })
                    });
                    if (respcontactos.status == 200) {
                        this.setReceptores(await respcontactos.json());
                        this.nuevoUsuario = {
                            nombre: "",
                            apellido1: "",
                            apellido2: "",
                            telefono: "",
                            email: "",
                            dni: "",
                        }
                    }
                    ElNotification({
                        title: "¡Bien!",
                        message: "El contacto se ha añadido correctamente",
                        type: "success",
                    });
                    this.mode = 'agenda';
                } else {
                    ElNotification({
                        title: "Oops",
                        message: "Ha ocurrido un error añadiendo el nuevo contacto",
                        type: "error",
                    });
                }
            }
            this.loading = false;
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
td,
th {
    border: 1px solid #ddd;
    padding: 8px;
}

tr:nth-child(even) {
    background-color: #f2f2f2;
}

tr:hover {
    background-color: #ddd;
}

th {
    padding-top: 12px;
    padding-bottom: 12px;
    text-align: left;
    background-color: #e6a23c;
    color: white;
}

tbody {
    display: block;
    height: 50vh;
    overflow: auto;
}

thead,
tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
    /* even columns width , fix width of table too*/
}

thead {
    width: 100%
        /* scrollbar is average 1em/16px width, remove it from thead width */
}

#colderecha {
    display: flex;
    flex-direction: column;
    align-items: center;
    max-height: calc(100vh - 20px);
    overflow: auto;
    padding: 10px 0px;

    @media(max-width: 400px) {
        height: 80vh;
    }

    .actionList {
        list-style: none;
        min-width: 50%;

        .tipodocumento {
            display: flex;
            flex-direction: column;
            cursor: pointer;
            padding: 10px;
            border: 2px solid #a9a9a929;
            margin-bottom: 10px;
            border-radius: 10px;
            font-weight: bold;
            transition: 0.5s;
            justify-content: flex-start;

            &:hover {
                background-color: #a9a9a929;
                border-color: #a9a9a929;
            }

            .icono {
                display: flex;
                justify-content: center;
                align-items: center;
                width: 50px;
                height: 50px;
                background: #0985e325;
                border-radius: 10px;
                margin-right: 10px;
            }
        }
    }

    .contenedoraplicaciones {
        width: calc(100% - 5px);
        list-style: none;
        padding-inline-start: 0;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-around;
        gap: 2.5px;

        @media(max-width: 1500px) {
            flex-direction: column;
        }

        li {
            @media(max-width: 1500px) {
                flex-basis: calc(50% - 20px);
            }

            @media(min-width: 1500px) {
                flex-basis: calc(33.33% - 20px);
                aspect-ratio: 2/1;
            }

            /* Ajusta este valor según tus necesidades */
            box-sizing: border-box;

            div {
                display: flex;
                align-items: center;
                text-align: left;
            }

            p {
                margin: 0px;
            }
        }
    }


    .tipodocumento {
        display: flex;
        flex-direction: column;
        cursor: pointer;
        padding: 10px;
        border: 2px solid #a9a9a929;
        margin-bottom: 10px;
        border-radius: 10px;
        font-weight: bold;
        transition: 0.5s;
        justify-content: flex-start;

        &:hover {
            background-color: #a9a9a929;
            border-color: #a9a9a929;
        }

        .icono {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50px;
            height: 50px;
            background: #0985e325;
            border-radius: 10px;
            margin-right: 10px;
        }

        .iconoconsulta {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50px;
            height: 50px;
            background: #1abc9c;
            border-radius: 10px;
            margin-right: 10px;
        }
    }
}
</style>